export const enum GAMING_QUICK_LINKS {
	CasinoQuickLinks = "HomepageCasino.quick-links",
	LiveCasinoQuickLinks = "HomepageLiveCasino.quick-links",
	ArcadeQuickLinks = "HomepageArcade.quick-links",
	SlotsQuickLinks = "HomepageSlots.quick-links",
}

export const enum PreviewSectionType {
	ActionBanner = "action-banner",
	FAQ = "faq-section",
	PlayWithUs = "play-with-us-section",
	Reassurance = "reassurance-section",
	SEO = "seo-section",
	SportsbookPreviewSection = "sportsbook-preview-section",
	GamingPreviewSection = "gaming-preview-section",
	ProductSelector = "product-selector",
}

export const PREVIEW_SECTION_LABEL = "preview-section";
